<template>
  <div class="login-container">
    <div class="left"></div>
    <div class="right">
      <div class="ykw">运营后台</div>
      <div class="login-form">
        <el-form ref="form" :model="formData" label-width="0" :rules="rules">
          <el-form-item prop="account">
            <div class="tip-icon">
              <img style="width:16px" src="~@/assets/icon/phone_icon.png" alt="" />
              <span>账号</span>
            </div>
            <el-input v-model="formData.mobile" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="tip-icon">
              <img style="width: 16px" src="~@/assets/icon/yanzheng_icon.png" alt="" />
              <span>验证码</span>
            </div>
            <el-input class="yan-input" v-model="formData.code" placeholder="请输入验证码">
              <template slot="append">
                <el-link
                    :type="isDisabled ? 'info' : 'primary'"
                    :disabled="isDisabled"
                    :underline="false"
                    @click="getCode"
                    class="yan_code"
                  >
                  {{ codeStr }}
                </el-link>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="login-btn">
              <el-button type="primary" @click="onSubmit">登录</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoginCodeAPI } from './api';

export default {
  name: 'Login',

  data() {
    return {
      isDisabled: false,
      imgCode: '',
      formData: {
        code: '',
        mobile: '',
      },
      rules: {},
      codeStr: '获取验证码'
    }
  },

  mounted() {},

  methods: {
    onSubmit() {
      this.$store.dispatch('Login', this.formData).then(() => {
        this.$router.push({ path: '/home' })
        sessionStorage.removeItem('keyPath')
      })
    },
     async getCode() {
      if(!this.formData.mobile) return this.$message.error('手机号必填')
      await getLoginCodeAPI(this.formData.mobile)
      this.isDisabled = true
      let sec = 59
      this.codeStr = `重发（${sec}s）`
      this.timer = setInterval(() => {
        sec = sec - 1
        this.codeStr = `重发（${sec}s）`
        if (sec <= 0) {
          this.codeStr = '获取验证码'
          this.isDisabled = false
          clearInterval(this.timer)
        }
      }, 1000)
    },
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  height: 100vh;
  .left {
    min-width: 500px;
    flex: 1;
    background: url('/bg.jpg') no-repeat;
    background-size: cover;
    background-position: center;
  }
  .right {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex: 0.4;
    min-width: 600px;
    padding: 72px;
    .logo-img {
      display: flex;
      align-items: center;
      margin-bottom: 32px;
      .left-logo {
        margin-right: 12px;
        width: 256px;
        height: 102px;
        img {
          width: 256px;
          margin-left: -40px;
        }
      }
      .right-txt {
        width: 78px;
        height: 24px;
        img {
          width: 78px;
          height: 24px;
        }
      }
    }
    .ykw {
      font-weight: 600;
      font-size: 24px;
      color: #1a1e25;
      line-height: 32px;
      margin-bottom: 20px;
    }
    .ykw-en {
      line-height: 32px;
      font-weight: 500;
      font-size: 16px;
      color: #788692;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .login-form {
      .tip-icon {
        display: flex;
        align-items: center;
        line-height: 30px;
        color: #1a1e25;
        font-size: 14px;
        img {
          margin-right: 8px;
        }
      }
      .yzm-img {
        height: 48px;
      }
      .yan-input /deep/{
        .el-input__inner {
          border-right: none;
        }
        .el-input-group__append {
          border-color: #1a1e25;
          background-color: #fff;
          border-left: none;
        }
        .yan_code {
          font-size: 16px;
          border-left: 1px solid #ccc;
          padding-left: 20px;
        }
      }
      .el-form /deep/ {
        .el-input__inner {
          border-color: #1a1e25;
          height: 48px;
        }
        .login-btn {
          display: flex;
          margin-top: 40px;
          .el-button {
            flex: 1;
            height: 48px;
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            background-color: #1b6fee;
            border-color: #1b6fee;
          }
        }
        .reset-btn {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 12px;
        }
      }
    }
  }
}
</style>
